import React from "react";
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';

import API from "@beardeddevops/react.api";
import APPCONFIG from "constants/Config";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";
import {Button} from "reactstrap";
import moment from "moment";
import {derivePaymentMethodLabel} from "utils/paymentMethodLabel";




class Transactions extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.limit = 16;
	}

	getItems(props) {

			let allItems = 0;

			//Collect item entry quantities and map to new array
			(props.original.transaction_itemss || []).forEach((item) => {
				allItems += item.quantity || 0;
			});

			//Products
			(props.original.transaction_productss || []).forEach(() => {
				allItems += 1;
			});

			//Consignments
			(props.original.transaction_consignmentss || []).forEach((consignment) => {
				allItems += consignment.quantity || 0;
			});

			//Services
			(props.original.transaction_servicess || []).forEach((service) => {
				allItems += service.quantity || 1;
			});

			//Trade-ins
			(props.original.transaction_tradess || []).forEach((trade) => {
				allItems += trade.quantity || 1;
			});

			return allItems;

	}

	render() {
		const {data, pages, loading,limit} = this.state;
		const extraColumns = [
			{
				Header: 'Purchase Price',
				id:"price",
				accessor:obj => (obj.cost ),
				show: !!this.state['column_price_cost'],
				toggle: 'column_price_cost'
			}
			];
	    let columns =
	      [
			{
				Header: "Date Time",
				id: "date",
				width: 120,
				accessor: d => {
					return moment(d.date).local().format("MM/DD/YYYY hh:mm A")
				}
			},
		    {
		      Header: "Order #",
			  id: "pkey",
		      className: 'center-column',
		      accessor: r => r.pkey,
		    },
		    {
				//Todo: Can't sort this column... suggesting that we throw this logic on the backend somehow and return one field.
		      Header: "Method",
		      id: "method",
		      accessor: derivePaymentMethodLabel,
		    },
		    {
		      Header: "Amount",
		      id: "amount",
		      className: 'right-column',
		      accessor: r => "$ " + (parseFloat(r.amount)).toFixed(2),

		    },
		    {
		      Header: "Tax",
		      id: "tax_amount",
		      className: 'right-column',
		      accessor: r => "$ " + (parseFloat(r.tax_amount)).toFixed(2),

		    },
		    {
		      Header: "Name",
		      id: "terminal_cardholder_name",
		      accessor: r => r.client ? r.client : r.terminal_cardholder_name,

		    },
		    {
		      Header: "Email",
		      id: "receipt_email",
		      accessor: r => r.receipt_email,

		    },
		    {
		      Header: "Description",
		      id: "description",
		      accessor: r => r.description,
		    },
		    {
			    //Todo: Might need a virtual column on the backend.. Not sure how to go about that (merging different items)
			    Header: "Items",
		      id: "items",
			    className: 'center-column',
		      /** @var r.transaction_itemss */
		      /** @var r.transaction_productss */
		      /** @var r.transaction_consignmentss */
			    accessor: r => r.transaction_itemss,
			    Cell: props => this.getItems(props)


		    },
		      {
			      Header: "User",
			      id: "user",
			      /** @var r.users */
			      accessor: r => r.users != null ? (r.users.name_first + " " + r.users.name_last) : (r.accounts.name_first + " " + r.accounts.name_last),
			      Cell: props => props.original.users != null ?
				      <Link to={"/users/" + props.original.users.pkey}>{props.value}</Link> :
				      <Link to={"/settings"}>{props.value}</Link>
		      },
		      {
			      Header: "Refunded",
			      id: "refunded",
			      className: 'center-column',
			      accessor: r => r.refunded.toString() === "true" ? "Refunded" : null
		      },
		    {
		      Header: "View",
			    sortable: false,
			    className: 'view-refund-cell',
			    Cell: props => (
		        <span>
		          <Link to={"/transactions/" + props.original.pkey}>
		            <Button className="primary-button pull-right" size={"sm"} block={true}><i
		              className={"fa fa-shopping-cart"}/>&nbsp;&nbsp;View /
		              Refund</Button>
		          </Link>
		        </span>
		      )
		    },
	  ];


		return (
			<Card>
				<CardContent>
				<div className="box-body">

					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch("Transactions")}
							{this.renderHeaderRight("Transactions",columns)}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns= {columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						showPagination= {true}
						showPaginationTop= {false}
						showPaginationBottom= {true}
						showPageSizeOptions= {true}
						defaultPageSize={limit}
						onPageSizeChange={this.onPageSizeChange}
						className="-striped -highlight"
						minRows={0}
					/>

				</div>
					{APPCONFIG.settings.isDev() ? null :
						<div className={classNames("tabled", "loader", {'active': loading})}>
							<ClipLoader color={"#4A4A4A"} loading={loading}/>
						</div>
					}
				</CardContent>
			</Card>
		)
	}
}
export default Framework.Components.withRootState(Transactions);


